/* eslint-disable no-template-curly-in-string */
export default {
  '@bingads-webui-campaign-react/audience-dashboard': {
    CampaignSelector_SelectCampaign: _TL_('Choose...'),
    CampaignSelector_EmptyList_Content: _TL_('No campaigns available.'),
  },
  '@bingads-webui-campaign/change-history-tab': {
    Filter_Operator_EQ: _TL_('equals'),
  },
  '@bingads-webui-campaign/inline-download-form': {
    Schema_DimensionRow_Property_AverageCPC: _TL_('Avg. CPC'),
    CronFormatter_FrequencyGrain_DropdownMenu_None: _TL_('None'),
  },
  '@bingads-webui-campaign/inline-download-reports': {
    Schema_DimensionRow_Property_AverageCPC: _TL_('Avg. CPC'),
    CronFormatter_FrequencyGrain_DropdownMenu_None: _TL_('None'),
  },
  '@bingads-webui-campaign/shared-budget-common': {
    Schema_Campaign_Property_Name: _TL_('Campaign name'),
    Schema_Budget_Property_Name: _TL_('Budget name'),
    Schema_Budget_Property_Type_Value_DailyAccelerated: _TL_('Accelerated'),
    Schema_Budget_Property_Type_Value_DailyStandard: _TL_('Standard'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    Filter_Operator_EQ: _TL_('equals'),
  },
  bam: {
    FilterLocalization_DataAttribute_Name: _TL_('{{entity}} name'),
    FilterLocalization_DataAttribute_Id: _TL_('{{entity}} ID'),
    FilterLocalization_DataAttribute_Status: _TL_('{{entity}} status'),
    FilterLocalization_DataAttribute_AveragePosition: _TL_('Avg. Pos.'),
    FilterLocalization_DataAttribute_StartDate: _TL_('Start date'),
    FilterLocalization_DataAttribute_EndDate: _TL_('End date'),
    FilterLocalization_DataAttribute_CompanyName: _TL_('Business name'),
    FilterLocalization_DataAttribute_FinalUrlSuffix: _TL_('Final URL Suffix'),
    EntityStatus_CampaignBudgetPaused: _TL_('Parent campaign budget paused'),
    EntityStatus_CampaignBudgetUserPaused: _TL_('Parent campaign budget and user paused'),
  },
  'campaignui/campaign-creation-advanced': {
    ColumnName_Title: _TL_('Ad title'),
    GoogleImport_PageTitle: _TL_('Import from Google AdWords'),
  },
  'campaignui/feature/accounts-summary': {
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    '': _TL_('See all {0}'),
  },
  'campaignui/feature/ad-customizers': {
    SimpleForm_Button_Save: _TL_('Set'),
  },
  'campaignui/feature/ad-groups-tab': {
    ColumnName_Medium: _TL_('Medium'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    Schema_Campaign_Property_BidStrategyName: _TL_('Bid strategy name'),
    '': _TL_('View-through conv. CPA'),
    ColumnName_EndDate: _TL_('End date'),
    Schema_AdGroup_Property_EndDate: _TL_('End date'),
    Schema_AdGroup_Property_StartDate: _TL_('Start date'),
    ColumnName_StartDate: _TL_('Start date'),
    ColumnField_Coupon_None: _TL_('-'),
    Error_Campaign_API_TrackingTemplateTooLong: _TL_('The tracking template entered is too long. The maximum length is 2048 characters.'),
    Filter_Operator_EQ: _TL_('equals'),
    Label_DeliveryStatus_AdExtensionAssociationDeleted: _TL_('Deleted'),
    Label_DeliveryStatus_AdExtensionDeleted: _TL_('Product Extension not created'),
    Label_DeliveryStatus_AdExtensionNotPresent: _TL_('Association excluded'),
    Schema_AdGroup_Property_Name: _TL_('Ad group name'),
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    Schema_PhonePerformanceMetrics_Property_ManualCalls: _TL_('Phone calls'),
    Message_DeliveryStatus_DomainLanguageNotSupported: _TL_('The website language for this DSA Campaign is not currently supported by Microsoft Advertising. Supported website languages include: English'),
    Error_Campaign_API_BidsAmountsGreaterThanCeilingPrice: _TL_('Bid amounts is greater than ceiling price.'),
    InputValueGreaterThanZero: _TL_('Enter a valid number greater than 0.'),
  },
  'campaignui/feature/adextension/shared': {
    Schema_Campaign_Property_CampaignName: _TL_('Campaign name'),
    Schema_Campaign_Property_Name: _TL_('Campaign name'),
    Schema_AdGroup_Property_Name: _TL_('Ad group name'),
    Label_DeliveryStatus_AdExtensionAssociationDeleted: _TL_('Deleted'),
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    '': _TL_('View-through conv. CPA'),
    Schema_PerformanceMetrics_Property_AuctionLostToLandingPercent: _TL_('IS lost to expected CTR'),
    Schema_PerformanceMetrics_Property_AuctionLostToAdQualityPercent: _TL_('IS lost to ad relevance'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    Filter_Operator_EQ: _TL_('equals'),
    ColumnName_StartDate: _TL_('Start date'),
    Label_DeliveryStatus_AdExtensionDeleted: _TL_('Product Extension not created'),
    Label_DeliveryStatus_AdExtensionNotPresent: _TL_('Association excluded'),
    Label_DeliveryStatus_LowSupply: _TL_('Below first page bid'),
  },
  'campaignui/feature/adextensions': {
    Schema_Campaign_Property_CampaignName: _TL_('Campaign name'),
    Schema_Campaign_Property_Name: _TL_('Campaign name'),
    Schema_AdGroup_Property_Name: _TL_('Ad group name'),
    Label_DeliveryStatus_AdExtensionAssociationDeleted: _TL_('Deleted'),
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    '': _TL_('View-through conv. CPA'),
    Schema_PerformanceMetrics_Property_AuctionLostToLandingPercent: _TL_('IS lost to expected CTR'),
    Schema_PerformanceMetrics_Property_AuctionLostToAdQualityPercent: _TL_('IS lost to ad relevance'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    Filter_Operator_EQ: _TL_('equals'),
    ColumnName_StartDate: _TL_('Start date'),
    Label_DeliveryStatus_AdExtensionDeleted: _TL_('Product Extension not created'),
    Label_DeliveryStatus_AdExtensionNotPresent: _TL_('Association excluded'),
    Label_DeliveryStatus_LowSupply: _TL_('Below first page bid'),
    FilePicker_ButtonText_ChooseFile: _TL_('Browse'),
  },
  'campaignui/feature/ads-tab': {
    Filter_Operator_EQ: _TL_('equals'),
    '': _TL_('Action'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    Schema_Ad_Property_Title: _TL_('Ad title'),
    Message_DeliveryStatus_DomainLanguageNotSupported: _TL_('The website language for this DSA Campaign is not currently supported by Microsoft Advertising. Supported website languages include: English'),
  },
  'campaignui/feature/auction-insight': {
    '': _TL_('Outranking share'),
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    Filter_Operator_EQ: _TL_('equals'),
  },
  'campaignui/feature/audience-campaign': {
    EntitySelector_Pagination_TotalPageCountText: _TL_(' of '),
  },
  'campaignui/feature/audiences': {
    Filter_Operator_EQ: _TL_('equals'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
  },
  'campaignui/feature/auto-targets': {
    '': _TL_('View-through conv. CPA'),
    Error_Campaign_API_BidsAmountsGreaterThanCeilingPrice: _TL_('Bid amounts is greater than ceiling price.'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
  },
  'campaignui/feature/bidlandscape': {
    InputValueGreaterThanZero: _TL_('Enter a valid number greater than 0.'),
  },
  'campaignui/feature/bulk-operation': {
    WeeklyOptions_0: _TL_('Email results'),
    Schema_Campaign_Property_CampaignName: _TL_('Campaign name'),
    Schema_Campaign_Property_Name: _TL_('Campaign name'),
    Schema_SharedEntityAssociation_Property_EntityName: _TL_('Campaign name'),
    ColumnName_Medium: _TL_('Medium'),
    Label_DeliveryStatus_AdExtensionDeleted: _TL_('Product Extension not created'),
    Label_DeliveryStatus_AdExtensionNotPresent: _TL_('Association excluded'),
    FilterLocalization_DeliveryStatusCategories_CampaignUserPaused: _TL_('User paused'),
    Schema_AdGroup_Property_EndDate: _TL_('End date'),
    Schema_AdGroup_Property_Name: _TL_('Ad group name'),
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    Schema_PhonePerformanceMetrics_Property_ManualCalls: _TL_('Phone calls'),
    ColumnName_StartDate: _TL_('Start date'),
    Schema_AdGroup_Property_StartDate: _TL_('Start date'),
    Schema_Campaign_Property_BidStrategyName: _TL_('Bid strategy name'),
    Schema_Ad_Property_Title: _TL_('Ad title'),
    Schema_Keyword_Property_FinalUrls: _TL_('Final URL'),
    Schema_Keyword_Property_MobileFinalUrls: _TL_('Mobile Final URL'),
    Schema_Keyword_Property_Text: _TL_('Keyword text'),
    Filter_Operator_EQ: _TL_('equals'),
  },
  'campaignui/feature/campaigns-tab/campaigns': {
    ColumnName_Name: _TL_('Campaign'),
    Schema_Campaign_Property_BidStrategyName: _TL_('Bid strategy name'),
    ColumnName_EndDate: _TL_('End date'),
    ColumnName_Status: _TL_('Campaign Status'),
    ColumnField_Coupon_None: _TL_('-'),
    '': _TL_('Conv.'),
    Message_DeliveryStatus_DomainLanguageNotSupported: _TL_('The website language for this DSA Campaign is not currently supported by Microsoft Advertising. Supported website languages include: English'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    Filter_Operator_EQ: _TL_('equals'),
    ColumnName_StartDate: _TL_('Start date'),
    Schema_Campaign_Property_CampaignName: _TL_('Campaign name'),
    Schema_Campaign_Property_Name: _TL_('Campaign name'),
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    Schema_PhonePerformanceMetrics_Property_ManualCalls: _TL_('Phone calls'),
    Label_DeliveryStatus_AdExtensionAssociationDeleted: _TL_('Deleted'),
    Label_DeliveryStatus_AdExtensionDeleted: _TL_('Product Extension not created'),
    Label_DeliveryStatus_AdExtensionNotPresent: _TL_('Association excluded'),
    Label_DeliveryStatus_LowSupply: _TL_('Below first page bid'),
    BudgetLandscape_BudgetSuggestions_HelpText_Forecasting_Non_Seasonal: _TL_('Your campaign will be limited by budget in the coming weeks, reducing how often your ads are shown. Increasing your budget can help you avoid losing potential customers.'),
    BudgetLandscape_BudgetSuggestions_HelpText_Recovery_Non_Seasonal: _TL_('Your campaign remains eligible, but it exhausted its daily budget in the last seven days. As a result, your ads were not displayed as frequently as possible. Increasing your budget can help ensure you capture potential customers without missing opportunities.'),
    BudgetLandscape_BudgetSuggestions_ActionText_Forecasting_Non_Seasonal: _TL_('Budget suggestion for coming weeks'),
    KPI_EstCost: _TL_('Weekly est. spend'),
    KPI_EstClick: _TL_('Weekly est. clicks'),
    KPI_EstImp: _TL_('Weekly est. Impr.'),
    KPI_EstMlImp: _TL_('Weekly est. top Impr.'),
  },
  'campaignui/feature/competition-tab': {
    ColumnName_EstimatedClicks: _TL_('Weekly est. clicks'),
    ColumnName_EstimatedImpressions: _TL_('Weekly est. impr.'),
    ColumnName_EstimatedConversions: _TL_('Weekly est. conv.'),
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    Filter_Operator_EQ: _TL_('equals'),
    Recommendation_Dismiss_Feedback_Popup_Title_NotToAutoApplySuggestedAds: _TL_("Don't auto-apply suggested ads"),
  },
  'campaignui/feature/conversion-tracking': {
    '': _TL_('Tag inactive'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    Schema_Goal_Property_Id: _TL_('UET tag ID'),
  },
  'campaignui/feature/dashboard-cards': {
    Filter_Operator_EQ: _TL_('equals'),
  },
  'campaignui/feature/demographics-tab': {
    Schema_PerformanceMetrics_Property_AuctionLostToLandingPercent: _TL_('IS lost to expected CTR'),
    Schema_PerformanceMetrics_Property_AuctionLostToAdQualityPercent: _TL_('IS lost to ad relevance'),
    '': _TL_('View-through conv. CPA'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    Filter_Operator_EQ: _TL_('equals'),
    GenericErrorMessage: _TL_("We've encountered an error. Please try again or contact support."),
    Schema_AdGroup_Property_Name: _TL_('Ad group name'),
    Schema_Campaign_Property_Name: _TL_('Campaign name'),
    Label_DeliveryStatus_AdExtensionAssociationDeleted: _TL_('Deleted'),
    Label_DeliveryStatus_AdExtensionDeleted: _TL_('Product Extension not created'),
    Label_DeliveryStatus_AdExtensionNotPresent: _TL_('Association excluded'),
    Label_DeliveryStatus_AdGroupCriterionExcluded: _TL_('Association excluded'),
    Label_DeliveryStatus_AdGroupCriterionPaused: _TL_('Association paused'),
    Schema_AdGroup_Property_DeliveryStatus_Value_LowSupply: _TL_('Below first page bid'),
    Label_DeliveryStatus_LowSupply: _TL_('Below first page bid'),
    Message_DeliveryStatus_DomainLanguageNotSupported: _TL_('The website language for this DSA Campaign is not currently supported by Microsoft Advertising. Supported website languages include: English'),
    BulkEdit_MissingPercentageError: _TL_('Enter a percentage amount.'),
  },
  'campaignui/feature/dimension': {
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    Schema_PerformanceMetrics_Property_ClickSharePercent: _TL_('Click Share'),
    '': _TL_('View-through conv. CPA'),
  },
  'campaignui/feature/experiments-tab': {
    CampaignSelector_EmptyList_Content: _TL_('No campaigns available.'),
    GenericErrorMessage: _TL_("We've encountered an error. Please try again or contact support."),
    ColumnName_Status: _TL_('Experiment status'),
    ColumnName_StartDate: _TL_('Start date'),
    Schema_Experiment_Property_StartDate: _TL_('Start date'),
    ColumnName_EndDate: _TL_('End date'),
    Schema_Experiment_Property_EndDate: _TL_('End date'),
    Grid_SearchTerm_TooMuchDataError_CmpLvl: _TL_('There is too much data to display.'),
    Filter_Operator_EQ: _TL_('equals'),
    ColumnName_AveragePosition: _TL_('Avg. pos'),
  },
  'campaignui/feature/feeds': {
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    Filter_Operator_EQ: _TL_('equals'),
    Schema_Keyword_Property_MatchType: _TL_('Target keyword match type'),
    Schema_Keyword_Property_Text: _TL_('Target keyword text'),
    Schema_PerformanceMetrics_Property_AuctionLostToLandingPercent: _TL_('Compare to IS lost to ad relevance'),
    Schema_PerformanceMetrics_Property_ClickSharePercent: _TL_('Click Share'),
  },
  'campaignui/feature/gmb-import': {
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    Schema_Enum_Status_Active: _TL_('Active'),
  },
  'campaignui/feature/hotel-center': {
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
  },
  'campaignui/feature/import-campaigns': {
    GoogleImport_NoCampaign: _TL_('It looks like you don’t have any campaigns in Google Ads, so we’ve canceled the import. Instead you can <a href="/campaign/welcome">create a new campaign</a> in Microsoft Advertising.'),
  },
  'campaignui/feature/inline-opportunity': {
    Suggested: _TL_('Suggested'),
    noBidLandscapeText: _TL_('The bid landscape is not available if the keyword is newly added or has low quality score, or if the campaign is limited by budget.'),
    InputValueGreaterThanZero: _TL_('Enter a valid number greater than 0.'),
  },
  'campaignui/feature/keywords-tab': {
    Schema_Keyword_Property_FinalUrls: _TL_('Final URL'),
    Schema_Keyword_Property_Text: _TL_('Keyword text'),
    bulkAdAppealTitle: _TL_('These keywords do not meet Microsoft Advertising policies. If you feel your content falls within policy, please submit an appeal and we will happily review the content again. '),
    Schema_Keyword_Property_MobileFinalUrls: _TL_('Mobile Final URL'),
    Schema_Campaign_Property_BidStrategyName: _TL_('Bid strategy name'),
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    Error_Campaign_API_TrackingTemplateTooLong: _TL_('The tracking template entered is too long. The maximum length is 2048 characters.'),
    Schema_SharedEntityAssociation_Property_EntityName: _TL_('Campaign name'),
    Filter_Operator_EQ: _TL_('equals'),
    DeliveryStatusIcon_Tooltip_Error: _TL_('Warning'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    Label_DeliveryStatus_AdExtensionDeleted: _TL_('Product Extension not created'),
    Label_DeliveryStatus_AdExtensionNotPresent: _TL_('Association excluded'),
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    '': _TL_('View-through conv. CPA'),
    Message_DeliveryStatus_DomainLanguageNotSupported: _TL_('The website language for this DSA Campaign is not currently supported by Microsoft Advertising. Supported website languages include: English'),
    InputValueGreaterThanZero: _TL_('Enter a valid number greater than 0.'),
    EntitySelector_Pagination_TotalPageCountText: _TL_(' of '),
  },
  'campaignui/feature/mobile/common': {
    Mobile_AddFunds_PaymentInfo_Title: _TL_('Payment method'),
  },
  'campaignui/feature/mobile': {
    OpportunityView_Front_Action: _TL_('Adding new keywords at a suggested bid of <b>{{suggestedBidValue}} USD</b>'),
    OpportunityView_Back_SuggestedBidValue: _TL_('USD ${{suggestedBidValue}}'),
  },
  'campaignui/feature/mobile/rn': {
    Error_Campaign_API_TrackingTemplateTooLong: _TL_('The tracking template entered is too long. The maximum length is 2048 characters.'),
  },
  'campaignui/feature/opportunity-edit-mode': {
    Suggested: _TL_('Suggested'),
  },
  'campaignui/feature/performance-targets': {
    Schema_Campaign_Property_Name: _TL_('Campaign name'),
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    Schema_PhonePerformanceMetrics_Property_ManualCalls: _TL_('Phone calls'),
    Schema_DimensionRow_Property_AverageCPC: _TL_('Avg. CPC'),
    Schema_Campaign_Property_BidStrategyName: _TL_('Bid strategy name'),
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    Filter_Operator_EQ: _TL_('equals'),
    Message_DeliveryStatus_DomainLanguageNotSupported: _TL_('The website language for this DSA Campaign is not currently supported by Microsoft Advertising. Supported website languages include: English'),
    FilterLocalization_DataAttribute_MonthlyBudget: _TL_('Maximum cashback spend'),
  },
  'campaignui/feature/product-feed': {
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
  },
  'campaignui/feature/responsive-search-ad': {
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    Schema_PerformanceMetrics_Property_Conversions: _TL_('Conversions'),
    Filter_Operator_EQ: _TL_('equals'),
  },
  'campaignui/feature/search-term': {
    Schema_AdGroup_Property_Name: _TL_('Ad group name'),
    Schema_Keyword_Property_Text: _TL_('Keyword text'),
    Schema_Campaign_Property_Name: _TL_('Campaign name'),
    Filter_Operator_EQ: _TL_('equals'),
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    '': _TL_('View-through conv. CPA'),
  },
  'campaignui/feature/shopping-campaign': {
    '': _TL_('High'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    Filter_Operator_EQ: _TL_('equals'),
    Error_Campaign_API_TrackingTemplateTooLong: _TL_('The tracking template entered is too long. The maximum length is 2048 characters.'),
  },
  'campaignui/feature/targeting-settings': {
    '': _TL_('View-through conv. CPA'),
    Error_Campaign_API_TrackingTemplateTooLong: _TL_('The tracking template entered is too long. The maximum length is 2048 characters.'),
    ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
    ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
    ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {0}'),
    EntitySelector_Pagination_TotalPageCountText: _TL_(' of '),
  },
  'component/api-errors-campaign': {
    Error_Campaign_API_BidsAmountsGreaterThanCeilingPrice: _TL_('Bid amounts is greater than ceiling price.'),
    Error_Campaign_API_ValueTooLong: _TL_('Value is too long'),
    '': _TL_('The list of CampaignCriterionActions is NullOrEmpty. Please see the ReasonCode element of this error object for details.'),
    Error_Campaign_API_InvalidCriterionId: _TL_('The Criterion ID is invalid.'),
    Error_Editorial_API_TooMuchText: _TL_('This dynamic text placeholder is causing one or more parts of your ad to exceed the character limits.'),
  },
  'component/language-selector': {
    Campaign_Language_Description: _TL_("Choose the language of the sites that you'd like your ads to appear on."),
  },
  'component/schema-i18n-campaign': {
    Schema_DimensionRow_Property_AverageCPC: _TL_('Avg. CPC'),
  },
  'component/upgraded-url': {
    Error_Campaign_API_TrackingTemplateTooLong: _TL_('The tracking template entered is too long. The maximum length is 2048 characters.'),
  },
  'shared-components/unified-notification-queue': {
    Loading: _TL_('...Loading...'),
  },
  'campaignui/feature/accounts-summary/data': {
    ColumnName_AvgPosition: _TL_('Avg. pos.'),
    '': _TL_('See all {0}'),
  },
  'global/data': {
    '': _TL_('Find "{3}" and replace with "{2}" in {0} {1}'),
  },
};
